import { AbstractControl } from '@angular/forms';
export const MatchPassword = function (AC: AbstractControl) {
    const password = AC.get('password').value; // to get value in input tag
    const confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password !== '' && password !== null && confirmPassword !== '' && confirmPassword !== null) {
        if (password !== confirmPassword) {
            AC.get('password').setErrors({ MatchPassword: true });
            AC.get('confirmPassword').setErrors({ MatchPassword: true });
        } else {
            // set errors except MatchPassword
            let passwordErrors = AC.get('password').errors;
            if (passwordErrors) {
                passwordErrors = filterOutMatchError(passwordErrors);
            }
            if (isEmpty(passwordErrors)) {
                AC.get('password').setErrors(null);
            } else {
                AC.get('password').setErrors(passwordErrors);
            }

            let confirmPasswordErrors = AC.get('confirmPassword').errors;
            if (confirmPasswordErrors) {
                confirmPasswordErrors = filterOutMatchError(confirmPasswordErrors);
            }
            if (isEmpty(confirmPasswordErrors)) {
                AC.get('confirmPassword').setErrors(null);
            } else {
                AC.get('confirmPassword').setErrors(confirmPasswordErrors);
            }

        }
    } else {
        return null;
    }
};

export const filterOutMatchError = function (errors) {
    const filteredErrors = {};
    for (const error in errors) {
        if (error) {
            if (error !== 'MatchPassword') {
                filteredErrors[error] = errors[error];
            }
        }

    }
    return filteredErrors;
};

export const isEmpty = function (obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};
